export const ActionType = {
  GetList: Symbol("GetTenantUserList"),
  Create: Symbol("CreateTenantUser"),
  Update: Symbol("UpdateTenantUser"),
  UpdateStatus: Symbol("UpdateTenantUserStatus"),
  Delete: Symbol("DeleteTenantUser"),
};
